import React from "react";
import { motion } from "framer-motion";
import "./../styles/contact.css";
import { FaUser, FaEnvelope, FaPhone, FaUserCircle, FaLock } from 'react-icons/fa';
import contactimg from "../images/contacimg.jpg"
import contactbottom from "../images/contactbottom.jpg"
import Footer from "../components/Footer.js"


const Contact =() =>{
    return(
      <>
<motion.div 
className="hero-section"
initial={{ opacity: 0, y: -50 }}

animate={{ opacity: 1, y: 0 }}
transition={{ duration: 0.5 }}
>

<div className="contact"> 
   <h2 className="contact-heading">Contact Us</h2>

   <b className="contact-para">
    "Get in touch with us and find out how we can ! </b>  <br></br>
<b className="contact1-para"> help you reimagine your enterprise for the digital."</b>
  
     </div>
    {/* ============================================================ contack form ============================================================== */}
<div className="contat-form-main-div">
  <div className="contact-form-main-left">
    <div className="contact-form-container">
      <h2>Contact Us</h2>
      <form className="contact-form">
        <div className="input-box">
          <FaUser className="icon" />
          <input type="text" required />
          <label>First Name</label>
        </div>

        <div className="input-box">
          <FaUser className="icon" />
          <input type="text" required />
          <label>Last Name</label>
        </div>

        <div className="input-box">
          <FaEnvelope className="icon" />
          <input type="email" required />
          <label>Email</label>
        </div>

        <div className="input-box">
          <FaPhone className="icon" />
          <input type="tel" required />
          <label>Contact Number</label>
        </div>

        <div className="input-box">
          <FaUserCircle className="icon" />
          <input type="text" required />
          <label>Username</label>
        </div>

        <div className="input-box">
          <FaLock className="icon" />
          <input type="password" required />
          <label>Password</label>
        </div>

        <button type="submit" className="submit-btn">Submit</button>
      </form>
    </div>
    </div>
    <div className="contact-form-main-right">
   <div className="contact-right-img-div">
   <img className="contact-img" src={contactimg}></img>

   </div>
 
    </div>
    </div>
    {/* ======================= contact us 3rd part ==================================== */}
    <div className="contact-3rd">
     <h5 class="thankyou-heading">THANKYOU FOR VALUABLE TIME !<br></br>
      REACH OUT FOR ANY QUESTIONS.
     </h5>
     <div >
      <img className="contact-bottom" src={contactbottom}></img>
     </div>
     <div className="contact-mid-words"> 
      <strong>WEBSITE</strong><br></br>
      <b>KNEWX.ERP.CO.IN</b><br></br><br></br>
      <strong>EMAIL ADDRESS</strong><br></br>
      <b>infoknewx@gmail.com</b><br></br><br></br>
      <strong>WHATSAPP</strong><br></br>
      <b>+91-83199-27756</b>
     </div>
     <div >
      <img className="contact-bottom1" src={contactbottom}></img>
     </div>

    </div>


   
</motion.div>
<br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br>
<br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br>
<br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br>
<Footer/>
</>
    );
}
export default Contact;